import pageHeader from "../components/pageHeader/locals/en.json";
import contactUsForm from "../components/contactUsForm/locals/en.json";
import contactUsInfo from "../components/contactUsInfo/locals/en.json";

export default {
  pageHeader,
  contactUsForm,
  contactUsInfo
};
